import {ProductGallery} from '../../components/glide'

const init = () => {
  ProductGallery()
}

export default init
